/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { ExternalStyles, useTheme } from 'bold-ui'
import { red } from 'bold-ui/lib/styles/colors'

import { useBadgeConfig } from './useBadgeConfig'

interface BaseBadgeProps {
  style?: ExternalStyles
  children?: JSX.Element
  color?: string
}

interface BadgeAutoProps extends BaseBadgeProps {
  type: 'auto'
  value: number | string | boolean
  maxLimit?: number
}

interface BadgeSmallProps extends BaseBadgeProps {
  type: 'small'
  value: boolean
}

interface BadgeLargeProps extends BaseBadgeProps {
  type: 'large'
  value: number | string
  maxLimit?: number
}

export type BadgeProps = BadgeAutoProps | BadgeSmallProps | BadgeLargeProps

export const BadgeNotificacao = ({ color = red.c50, ...props }: BadgeProps) => {
  const theme = useTheme()
  const { finalColor, isLarge, isOverPictograma, displayValue, shouldRenderBadge } = useBadgeConfig(props, color)

  if (!shouldRenderBadge) {
    return props.children ?? null
  }

  const styles = createStyles(theme, finalColor)
  const typeStyle = isLarge ? styles.large : styles.small
  const badgeContent = <div css={[styles.badge, typeStyle]}>{displayValue}</div>

  return (
    <div css={[props.style, styles.wrapper]}>
      {isOverPictograma ? (
        <div
          css={css`
            position: relative;
          `}
        >
          <div css={[styles.positionStyles, styles.pictograma]}>{badgeContent}</div>
          {props.children}
        </div>
      ) : (
        badgeContent
      )}
    </div>
  )
}

const createStyles = (theme, finalColor) => ({
  positionStyles: css`
    top: -8px;
    left: 100%;
    transform: translate(-50%, 0);
  `,
  wrapper: css`
    position: relative;
    display: inline-flex;
  `,
  badge: css`
    background-color: ${finalColor};
    border-radius: 12px;
    align-items: center;
    display: inline-flex;
    justify-content: center;
    white-space: nowrap;
  `,
  large: css`
    padding: 2px 4px;
    height: 16px;
    width: auto;
    min-width: 16px;
    color: ${theme.pallete.surface.main};
    font-size: 10px;
    font-weight: bold;
  `,
  small: css`
    width: 8px;
    height: 8px;
  `,
  pictograma: css`
    border: ${`2px solid ${theme.pallete.surface.main}`};
    margin: ${'-2px'};
    border-radius: 12px;
    display: inline-flex;
    position: absolute;
  `,
})
